export default class ResponsiveTableController {
    constructor() {
        this.selector = 'body table';

        this.init();
    }

	init() {
		document.querySelectorAll(this.selector).forEach(table => {
			// console.log(table);
            this.clean(table);
            // this.prepare(table);
            
            // this.fillEmptyCells(table);
		    // this.addRowHeaders(table);
		});
    }
    
    clean(table) {
		// table.querySelectorAll('*').forEach(el => el.removeAttribute('style'));

		let tableInlineStyles = Array.prototype.slice.call(table.style);

		if (tableInlineStyles.includes('width')) {
			table.style.removeProperty('width');
		}

		if (tableInlineStyles.includes('height')) {
			table.style.removeProperty('height');
		}

		table.querySelectorAll('*').forEach(el => {
			let inlineStyles = el.style;

			if (inlineStyles.width) {
				el.style.removeProperty('width');
			}

			if (inlineStyles.height) {
				el.style.removeProperty('height');
			}
		});
		
    }

	prepare(table) {
		if (!table.querySelectorAll('thead').length) {
			this.createTableHead(table);
		}
	}

	createTableHead(table) {
		let thead = document.createElement('thead');
		thead.appendChild(table.querySelector('tr'));
		table.prepend(thead);
	}

	addRowHeaders(table) {
		// Create an array of the thead values        
		let headers = [];
		table.querySelectorAll('thead tr td').forEach(header => headers.push(header.innerHTML));

		// Prepend headers to all tbody rows
		table.querySelectorAll('tbody tr').forEach(row => {
			headers.forEach((header, index) => {
				let headerSpan = document.createElement('span');
				headerSpan.classList.add('mobileHeader');
				headerSpan.innerHTML = header;

				row.querySelectorAll('td')[index].prepend(headerSpan);
			});
		});
	}

	fillEmptyCells(table) {
		// When a column has mostly the same values, any same following cell is often kept empty
		// Due to how the responsive tables work, it's better to keep them filled in on mobile

		let currentRowValues = [];
		table.querySelectorAll('tbody tr').forEach((row, index) => {
			/* console.log(`Starting row ${index + 1}`); */
			row.querySelectorAll('td').forEach((cell, col) => {
				if (cell.innerHTML.trim() !== '' && cell.innerHTML.trim() !== '&nbsp;') {
					currentRowValues[col] = cell.innerHTML;
				} else if (currentRowValues[col] !== undefined) {
				/* console.log(`Column ${col + 1} is empty, filling with "${currentRowValues[col]}"`); */

					let tempDiv = document.createElement('div');
					tempDiv.innerHTML = currentRowValues[col];
				
					cell.removeChild(cell.firstChild);
					cell.appendChild(tempDiv.firstChild);
					cell.classList.add('wasEmpty');
					/* console.log(cell); */
				}
			});
			/* console.log(`---------------------------------------------`); */
		});
	}
}